import { useMemo } from 'react';

import type { PatternDesignOptimisation } from '~api/services';
import type { OptimisationDrillHoleProperties } from '~types';
import { extractDrillHole } from '../utils/drill-hole-helpers';

/**
 * Hook to extract and process drill hole data from pattern design
 * @param {PatternDesignOptimisation | null} optimisation - The pattern design optimisation data
 * @returns {OptimisationDrillHoleProperties[]} Array of processed drill hole data
 */
export const useDrillHoleData = (optimisation: PatternDesignOptimisation | null): OptimisationDrillHoleProperties[] => {
  return useMemo(() => {
    if (!optimisation?.pattern_design?.features) return [];

    return optimisation.pattern_design.features
      .map((feature, index) => extractDrillHole(feature, index))
      .filter((hole): hole is OptimisationDrillHoleProperties => hole !== null);
  }, [optimisation]);
};
